<mat-form-field class="pr-3">
  <mat-label>Contact Type</mat-label>
  <mat-select [disabled]="readonly" data-cy="contact-type" (selectionChange)="onCategorySelect($event)">
    <ng-container *ngIf="categories$ | async as categories">
      <mat-option *ngFor="let category of categories" [value]="category">
        {{ category.name }}
      </mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>
